export enum PaginationModifier {
  BORDER_TOP = 'border-top',
}
